<template>
  <section class="info-section">
    <h3
      class="section-title"
      :class="{ 'section-title--empty': histories.length === 0 }"
    >
      頻回アラート対応履歴{{ histories.length === 0 ? ' 無し' : '' }}
    </h3>
    <table
      v-if="histories.length > 0"
      class="info-table"
    >
      <thead>
        <tr>
          <th>対応日時</th>
          <th>対応</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="history in histories"
          :key="history.id"
        >
          <td class="date-cell">
            {{ displayValue(history.respondedAt) }}
          </td>
          <td>{{ displayValue(history.responseLabel) }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script setup>
defineProps({
  histories: {
    type: Array,
    default: () => [],
  },
});

const displayValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};
</script>

<style lang="scss" scoped>
.info-section {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  padding: 10px;
  margin-bottom: 10px;
}

.section-title {
  color: #c8384f;
  font-size: clamp(16px, 1vw, 20px);
  line-height: 1.25;
  font-weight: 700;
  margin-bottom: 6px;
}

.section-title--empty {
  color: #888;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
}

.info-table thead {
  background: #efefef;
}

.info-table th,
.info-table td {
  text-align: left;
  border-bottom: 1px solid #e4e4e4;
  padding: 6px;
  font-size: 12px;
  line-height: 1.45;
  color: #333;
  vertical-align: top;
}

.info-table td.date-cell {
  color: #999;
}
</style>
